export default __webpack_public_path__ + "static/media/Custom-HUD-Targeting (Reticle, 2L).26661981.jpg";